export enum DirectionEnum {
    ASC = 'ASC',
    DESC = 'DESC',
}
